import type { SitePhoto } from '@/hooks/useAssetOverrides';

type Props = {
  photos: SitePhoto[];
  onOpen?: (url: string) => void;
  className?: string;
};

/** Renders admin-added photos inside an existing gallery grid. */
export default function ExtraPhotos({ photos, onOpen, className = 'col-span-4 aspect-[4/3]' }: Props) {
  return (
    <>
      {photos.map((p) => (
        <div
          key={p.id}
          className={`${className} image-zoom rounded-sm overflow-hidden ${onOpen ? 'cursor-pointer' : ''}`}
          onClick={() => onOpen?.(p.url)}
        >
          <img
            src={p.url}
            alt={p.alt_text || 'Sivota Royal photo'}
            className="w-full h-full object-cover hero-image-bright"
            loading="lazy"
          />
        </div>
      ))}
    </>
  );
}
